module.exports = __webpack_public_path__ + "static/homepageHero2@3x-0644aff8ef47ba8134ba2605b240fb69.png";